export const isUserSid = () => app.config.currentUser.primaryProvider === 'sid';
